import { QueryType } from '@/app/types/types'
import axios from 'axios'

const getUserRequest = async (params?: QueryType) => {
    if (process.env.NODE_ENV === 'development') {
        console.log('[getUserRequest] Starting user request at:', new Date().toISOString())
    }
    try {
        if (process.env.NODE_ENV === 'development') {
            console.log('[getUserRequest] Making API call to /api/user-data')
        }
        const response = await axios.get('/api/user-data', {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
            params,
        })
        if (process.env.NODE_ENV === 'development') {
            console.log('[getUserRequest] API call successful, received data:', {
                status: response.status,
                hasData: !!response.data,
            })
        }
        return response
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred'
        const errorResponse = axios.isAxiosError(error) ? error.response?.status : undefined

        console.info('[getUserRequest] Error in API call:', {
            message: errorMessage,
            status: errorResponse,
            timestamp: new Date().toISOString(),
        })
        throw error
    }
}

const updateUserRequest = async (params: QueryType, data: any) => {
    if (process.env.NODE_ENV === 'development') {
        console.log('[getUserRequest] Starting user request at:', new Date().toISOString())
    }
    try {
        if (process.env.NODE_ENV === 'development') {
            console.log('[getUserRequest] Making API call to /api/user-data')
        }
        const response = await axios.put('/api/user-data', data, {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
            params,
        })
        if (process.env.NODE_ENV === 'development') {
            console.log('[getUserRequest] API call successful, received data:', {
                status: response.status,
                hasData: !!response.data,
            })
        }
        return response
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred'
        const errorResponse = axios.isAxiosError(error) ? error.response?.status : undefined

        console.error('[getUserRequest] Error in API call:', {
            message: errorMessage,
            status: errorResponse,
            timestamp: new Date().toISOString(),
        })
        throw error
    }
}

export { getUserRequest, updateUserRequest }
